import { MouseEvent, ChangeEvent } from 'react'
import type { Book } from '@/types'
import { formatAuthors } from '../../formattingUtils'

interface BookWithProfile extends Book {
    profiles?: {
        full_name?: string
    }
}

interface CompactCardsViewProps {
    books: BookWithProfile[]
    selectedIds: Set<string>
    toggleBookSelection: (e: MouseEvent | ChangeEvent, bookId: string) => void
    onBookClick: (book: BookWithProfile) => void
    initiateDelete: (e: MouseEvent, bookId: string) => void
    isBiblioverso: boolean
    isSharedView: boolean
}

export default function CompactCardsView({
    books,
    selectedIds,
    toggleBookSelection,
    onBookClick,
    initiateDelete,
    isBiblioverso,
    isSharedView,
}: Readonly<CompactCardsViewProps>) {
    return (
        <div className="books-grid compact-grid animate-fade-in">
            {books.map((book, index) => {
                const isSelected = selectedIds.has(book.id)
                return (
                    <article
                        key={book.id}
                        className={`compact-card animate-fade-in-up stagger-${Math.min(index + 1, 5)} clickable ${isSelected ? 'is-selected' : ''}`}
                        onClick={() => onBookClick(book)}
                        data-testid={`book-card-${book.title}`}
                    >
                        <label className="book-checkbox-wrapper" onClick={(e) => e.stopPropagation()}>
                            <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={(e) => toggleBookSelection(e, book.id)}
                                onClick={(e) => e.stopPropagation()}
                                className="book-checkbox-input"
                            />
                            <span className="book-checkbox"></span>
                        </label>
                        <div className="compact-content">
                            <h4 className="compact-title">{book.title}</h4>
                            <span className="compact-author">{formatAuthors(book.author)}</span>
                        </div>
                        {isBiblioverso && book.profiles?.full_name && (
                            <div className="compact-owner">👤 {book.profiles.full_name}</div>
                        )}
                        {!isBiblioverso && !isSharedView && (
                            <button onClick={(e) => initiateDelete(e, book.id)} className="card-delete hover-show" data-testid="delete-book-button">
                                🗑️
                            </button>
                        )}
                    </article>
                )
            })}
        </div>
    )
}
